import {type ClassValue, clsx} from 'clsx';
import {extendTailwindMerge} from 'tailwind-merge';

// Extend tailwind-merge to recognize custom text size classes
// This prevents custom classes like text-display-1, text-heading-1, etc. from being removed
//
// Configuration approach: Add custom text-* classes to the 'font-size' class group
// Format: { text: ['suffix'] } where 'suffix' is the part after 'text-'
// This tells tailwind-merge these are valid text-* size variants that shouldn't conflict
// with standard Tailwind text utilities (text-sm, text-lg, etc.)
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            // Custom display sizes (suffix only, without 'text-' prefix)
            'display-1',
            'display-2',
            'display-3',
            // Custom heading sizes
            'heading-1',
            'heading-2',
            'heading-3',
            'heading-4',
            // Custom body sizes
            'body-xl',
            'body-lg',
            'body-responsive',
            'body-sm-responsive',
            'label',
            'caption',
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
